<template>
  <div>
    <template v-for="(resumeList, listIndex) in getStoreResumeList.list">
      <div class="talentList managementList" :key="listIndex + '&talentList'" v-if="jobRecommendIndex===0 ? true: listIndex===jobRecommendIndex-1">

        <template v-for="(item, index) in resumeList.rec_resumes">
        
          <div class='list bg_fff cursor_p pr' data-growing-title='简历卡片' data-growing-container  :key="index + '&list'" @click="getDetail({item,index, listIndex})" v-if="!item.unsuitableCardState">
            
            <div class="topContent bg_fa clearfix f_14 color_9c">
              <div class="text beforeText fl">
                期望：
                <span class="display_ib" v-if="item.resume.info.basic_info.predict_cities && item.resume.info.basic_info.predict_cities.length">{{item.resume.info.basic_info.predict_cities.join('/')}}</span>
                <span class="display_ib" v-else-if="item.resume.info.basic_info.expected_cities && item.resume.info.basic_info.expected_cities.length">{{item.resume.info.basic_info.expected_cities.join('/')}}</span>
                <span class="display_ib" v-if="item.resume.info.profile.exp_job">{{item.resume.info.profile.exp_job}}</span>
                <span class="display_ib">{{expected_salary(item.resume.info.profile.expected_salary) || '面议'}}</span>
              </div>
              <el-tooltip class="unsuitable iconfont iconcha color_9c text_center cursor_p" effect="dark" content="不感兴趣" placement="left">
                <!-- <div class="fr" v-if="!item.unsuited" @click.stop="handleClickUnsuitable(listIndex, index)"></div> -->
                <div class="fr" v-if="!item.unsuited" @click.stop="toggleUnsuitableState(listIndex, index, true)"></div>
              </el-tooltip>
            </div>

            <div class="userInfo flex">
              <!-- 头像 -->
              <div :class="['headImg pr', !userInfoState ? 'informationBlur' : '']" >
                <div class="pa img" :style="{backgroundImage:'url('+ (item.resume.info.profile.avatar_url || headImgList.round[item.resume.user_id%5]) +')',backgroundSize:'cover'}"></div>
                <div class="gender pa iconfont" :class="[item.resume.info.profile.gender==='男'?'iconnan':'',item.resume.info.profile.gender==='女'?'iconnv':'',]"></div>
              </div>

              <!-- 中间内容区域 -->
              <div class="centerContent clearfix flex1 hasHighlightLength">
                <!-- 用户基本信息及 学校信息 -->
                <div class="leftCont fl">
                  <!-- 用户名 -->
                  <div class="userName clearfix">
                    <div class="name color_40 f_18 font_w_b pr fl" :class="[ !userInfoState ? 'informationBlur4' : '']">{{item.resume.info.profile.username}}</div>
                    <div class="onlineAt f_14 color_9c fl" v-if="lastActiveAt(item.resume.info.basic_info.updated_at)" >{{lastActiveAt(item.resume.info.basic_info.updated_at)}}</div>
                  </div>
                  <div class="leftItem color_40 f_14 beforeText" style="margin-bottom:18px">
                    <!-- 年纪 -->
                    <span class="display_ib" v-if="getAge(item.resume.info.profile.birthday)" >{{getAge(item.resume.info.profile.birthday)}}</span>
                    <!-- 工作年限/毕业时间 -->
                    <span class="display_ib" v-if="workingYears({profession_identity: item.profession_identity, years_of_work_experience:item.years_of_work_experience, graduate_at:item.resume.info.basic_info.graduate_at})" >{{workingYears({profession_identity: item.profession_identity, years_of_work_experience:item.years_of_work_experience, graduate_at:item.resume.info.basic_info.graduate_at})}}</span>
                    <!-- 最高学历 -->
                    <span class="display_ib" v-if="getDegreeName(item.resume.info, item.recent_edu_index)" >{{getDegreeName(item.resume.info, item.recent_edu_index)}}</span>
                  </div>
                  <template v-for="(sitem, sindex) in item.resume.info.education_experiences">
                    <div class="leftItem color_40 f_14 clearfix" :key="sindex + '&talentListItem'" v-if="sindex<2">
                      <div class="beforeText ellipsis fl leftItemTags">
                        <!-- 学校名称 -->
                        <span v-if="sitem.cust_uni_name || sitem.school.cn" >{{sitem.cust_uni_name || sitem.school.cn}}</span>
                        <!-- 专业 -->
                        <span v-if="sitem.cust_major_name || sitem.major_name.cn" >{{sitem.cust_major_name || sitem.major_name.cn}}</span>
                        <!-- 学历 -->
                        <span v-if="sitem.cust_degree || sitem.degree_name.cn" >{{sitem.cust_degree || sitem.degree_name.cn}}</span>
                        <span v-if="sitem.edu_type==='非全日制'" >非全日制</span>
                      </div>
                      <div class="schoolTag f_12 color_blue fl" v-if="schoolTag(sitem.school.tag_names)">{{schoolTag(sitem.school.tag_names)}}</div>
                    </div>
                  </template>

                </div>
                <div class="fl flex" style="overflow: inherit; width: 55%;">
                  <!-- 工作经历 -->
                  <div class="workList pr flex1">
                    <!-- 左侧分割线 -->
                    <div class="divid pa text_center color_fff">
                      <div class="start iconfont iconGroup32 pa"></div>
                      <div class="end iconfont iconGroup32 pa"></div>
                    </div>

                    <div class="item" v-if="!(filterWork(item.resume.info.work_experiences).length + filterWork(item.resume.info.internship_experiences).length)">
                      <div class="name f_14 color_40 beforeText">暂无工作经历</div>
                    </div>

                    <template v-else >
                      <!-- 有工作经历 -->
                      <template v-if="filterWork(item.resume.info.work_experiences).length">
                        <template v-for="(item,index) in filterWork(item.resume.info.work_experiences, item.keyword_hit)" >
                          <div class="item" :key="'works&' + index" v-if="index<2">
                            <div class="text f_12 color_9c beforeText">
                              <span class="display_ib time" v-if="item.start_at||item.end_at || item.present">
                                <i v-if="item.start_at">{{splitTime(item.start_at)}}</i>
                                <i v-if="item.end_at || item.present">{{splitTime(item.end_at || item.present)}}</i>
                              </span>
                              <span class="display_ib">就职</span>
                              <span class="display_ib" v-if="getWorkTimeLength({start_at: item.start_at, end_at: item.end_at, present:item.present})">{{getWorkTimeLength({start_at: item.start_at, end_at: item.end_at, present:item.present})}}</span>
                            </div>
                            <div class="name f_14 color_40 beforeText ellipsis">
                              <span v-if="item.company_name" v-html="item.company_name"></span>
                              <span v-if="item.title" v-html="item.title"></span>
                            </div>
                          </div>
                        </template>
                      </template>
                      <!-- 实习经历 -->
                      <template v-if="filterWork(item.resume.info.work_experiences).length<2 && filterWork(item.resume.info.internship_experiences).length">
                        <template v-for="(sitem,sindex) in filterWork(item.resume.info.internship_experiences, item.keyword_hit)" >
                          <div class="item" :key="'internships&' + sindex" v-if="sindex < (filterWork(item.resume.info.work_experiences).length ? 1 : 2)">
                            <div class="text f_12 color_9c beforeText">
                              <span class="display_ib time" v-if="sitem.start_at||sitem.end_at || sitem.present">
                                <i v-if="sitem.start_at">{{splitTime(sitem.start_at)}}</i>
                                <i v-if="sitem.end_at || sitem.present">{{splitTime(sitem.end_at || sitem.present)}}</i>
                              </span>
                              <span class="display_ib">实习</span>
                              <span class="display_ib" v-if="getWorkTimeLength({start_at: sitem.start_at, end_at: sitem.end_at, present:sitem.present})">{{getWorkTimeLength({start_at: sitem.start_at, end_at: sitem.end_at, present:sitem.present})}}</span>
                            </div>
                            <div class="name f_14 color_40 beforeText ellipsis">
                              <span v-if="sitem.company_name" v-html="sitem.company_name"></span>
                              <span v-if="sitem.title" v-html="sitem.title"></span>
                            </div>
                          </div>
                        </template>
                      </template>
                      
                      <!-- 项目经历 -->
                      <template v-if="(filterWork(item.resume.info.work_experiences).length + filterWork(item.resume.info.internship_experiences).length)<2 && filterCustomSections(item.resume.info.project_experiences).length">
                        <template v-for="(sitem, sindex) in filterCustomSections(item.resume.info.project_experiences)" >
                          <div class="item" :key="'project_experiences&' + sindex" v-if="sindex<1">
                            <div class="text f_12 color_9c beforeText">
                              <span class="display_ib time" v-if="sitem.start_at||sitem.end_at || sitem.present">
                                <i v-if="sitem.start_at">{{splitTime(sitem.start_at)}}</i>
                                <i v-if="sitem.end_at || sitem.present">{{splitTime(sitem.end_at || sitem.present)}}</i>
                              </span>
                              <span class="display_ib">项目</span>
                            </div>
                            <div class="name f_14 color_40 beforeText ellipsis">
                              <span v-if="sitem.name">{{sitem.name}}</span>
                              <span v-if="sitem.title">{{sitem.title}}</span>
                            </div>
                          </div>
                        </template>
                      </template>
                      <!-- 社团经历 -->
                      <template v-if="(filterWork(item.resume.info.work_experiences).length + filterWork(item.resume.info.internship_experiences).length)<2 && !filterCustomSections(item.resume.info.project_experiences).length && filterInfoSections(item.resume.info.orgs).length">
                        <template v-for="(sitem, sindex) in filterInfoSections(item.resume.info.orgs)" >
                          <div class="item" :key="'orgs&' + sindex" v-if="sindex<1">
                            <div class="text f_12 color_9c beforeText">
                              <span class="display_ib time" v-if="sitem.start_at||sitem.end_at || sitem.present">
                                <i v-if="sitem.start_at">{{splitTime(sitem.start_at)}}</i>
                                <i v-if="sitem.end_at || sitem.present">{{splitTime(sitem.end_at || sitem.present)}}</i>
                              </span>
                              <span class="display_ib">社团</span>
                            </div>
                            <div class="name f_14 color_40 beforeText ellipsis">
                              <span v-if="sitem.name">{{sitem.name}}</span>
                              <span v-if="sitem.title">{{sitem.title}}</span>
                            </div>
                          </div>
                        </template>
                      </template>
                    </template>
                  </div>
                  <div class="features pr">
                    <div class="funtionButton f_14 color_blue cursor_p pr"  @click.stop="resumeApply(item.hr_permission_state, item, {listIndex, index})">
                      <span class="iconfont iconGroup311" v-if="(item.resume.contact_directly) && !item.hr_permission_state"></span>
                      {{!item.hr_permission_state && !item.delivery_status ? '联系Ta' : '继续沟通'}}
                      <div class="tips pa f_14 color_9c text_center bg_fff" v-if="(item.resume.contact_directly) && !item.hr_permission_state">该人才可直接获取电话</div>
                    </div>
                  </div>

                </div>
                
              </div>
              
            </div>
            <!-- 底部信息 -->
            <div class="message clearfix color_9c f_14">
              <div class="fl">根据 {{resumeList.job_name}} 推荐</div>
              <div class="favorite f_14 color_40 cursor_p fr" @click.stop="resumeCollect(item, index, listIndex)"><span class="iconfont pr" :class="[item.is_favorite ? 'iconfavoritesactive current':'iconfavorites color_9c']"></span> {{item.is_favorite?'移除储备':'储备'}}</div>
            </div>

          </div>

          <div class="unsuitableCard bg_fff" data-growing-title='简历卡片' data-growing-container  :key="index + '&unsuitableCard'" v-else>
            <div class="name f_14">
              <span class="color_blue iconfont iconjinggao"></span>
              <span class="color_40">告诉我们不感兴趣的原因，我们将为你推荐更合适的人才</span>
              <span class="colose fr color_9c_hover cursor_p" @click.stop="toggleUnsuitableState(listIndex, index, false)">撤销</span>
            </div>
            <div class="markValList clearfix f_14">
              <div class="tag fl color_9c cursor_p transition_2" v-for="sitem in markValList" :key="sitem.id + '&markValList'" @click="toggleMarkVal(sitem, listIndex, index)">{{sitem.label}}</div>
            </div>

          </div>
        </template>
      </div>
    </template>

    <!-- 申请简历弹窗 -->
    <resume-apply v-if="showResumeApplyState" />
    <!-- 简历详情 -->
    <resume-detail-box @hideDetails="hideDetails" v-if="showDetail" @getDetail="getDetail" />
    <!-- 标记不合适 -->
    <unsuitable v-if="unsuitableData.showState" @hideDetails="hideDetails" />
    <!-- 绑定手机号弹窗 -->
    <bind-phone v-if="showBindPhone" @bindPhoneSuccess="bindPhoneSuccess" @closeBindPhone="closeBindPhone" />

  </div>
</template>

<script>
  //混入优化
  import {mixinsUtils} from '@/mixins/search/utils';
  // 所有接口
  import actions from '@/actions/index'

  import { checkUserState , get_tUser } from '@/utils/utils';
  import { filterInfoSections, filterCustomSections, getAge, applied_at, getDegreeName, schoolTag, getWorkTimeLength } from '@/utils/resumeList';

  import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
  //申请简历
  import ResumeApply from '@/components/block/ResumeApply'
  //简历详情
  import ResumeDetailBox from '@/components/resumeDetailBox/index'
  import unsuitable from '@/components/delivery/Unsuitable'
  //绑定手机号
  import BindPhone from '@/components/bindPhone'

  export default {
    name: 'deliveryList',
    mixins: [mixinsUtils],
    props: {
      jobRecommendIndex:{},
    },
    data() {
      return {
        // showResumeApplyState: false, //是否显示申请简历弹窗
        userJWT:{},
        showBindPhone: false, //是否显示绑定手机号弹窗
        bindData:{}, //账户绑定数据
        checkRequestState: { //接口请求状态
          resumeApply: false,
          downLoad: false,
        },
        showDetail: false,
        markValList: [{ //不合适原因
          id:0,
          label:'学历不符',
        },{
          id:1,
          label:'专业不符',
        },
        {
          id:2,
          label:'技能不符',
        },{
          id:3,
          label:'过往经历不符',
        },{
          id:4,
          label:'工作年限不符',
        }],
      }
    },
    components: {
      ResumeApply,
      ResumeDetailBox,
      unsuitable,
      BindPhone,
    },
    computed: {
      ...mapState('block', ['userInfoState', 'userinfoTipsState', 'showResumeApplyState', 'unsuitableData']),
      ...mapState('delivery', ['deliveryList']),
      ...mapState('resumeDetails',['resumeDetail', 'myPosition']),
      ...mapState('im',['hr_account_token']),
      ...mapGetters('resumeDetails',[ 'getStoreResumeList'] ),
    },
    created() {
      this.userJWT = get_tUser();
      // 获取用户绑定信息
      this.getUsersBind();
    },
    methods: {
      ...mapMutations('block', ['toggleUserInfoState', 'toggleUserinfoTips', 'toggleTipsType', 'updateBlockStateFun']),
      ...mapMutations('im', ['updateSmallChatOpenId']),
      ...mapMutations('delivery', ['updateUnviewedJobDeliveriesCount', 'updateDeliveryListData']),
      ...mapMutations('resumeDetails', ['updateResumeDetail', 'updateResumeListObj', 'updateSearchIndexObj','updateDownloadResumeInfo']),
      ...mapActions('resumeDetails',['getMyPosition']),
      //进入详情页
      async getDetail({item, index, listIndex}) {
        this.updateDownloadResumeInfo(item)
        //检查是否完善信息，及更换用户
        const checkUser = await checkUserState({
          //不是hr
          callback1: () => {
            this.$router.replace({name: 'talentSearchIndex'});
            return false;
          },
          callback2: () => {
            //列表回到第一页，刷新数据
            location.reload();
            return false;
          },
        });

        // 更新搜索主页参数
        this.updateSearchIndexObj({
          listIndex,
          itemIndex: index,
        });

        //更改未读状态
        this.toggleViewed(listIndex, index);

        let token = item.resume.token;

        if(this.userJWT.h_t){
          //获取职位列表
          this.getMyPosition();
        }

        //更新页面数据
        this.updateResumeDetail(item);

        actions.hr_accounts.postResumesActivities({
          token:token,
          acts: ['viewed'],
          job_id: item.job_id
        })
        //简历详情相关url 及 参数，用作收藏等交互
        // this.updateResumeDetailToken(options.token);

        //显示弹层
        this.showDetail = true;

      },

      //收藏/取消收藏
      async resumeCollect(item, index, listIndex) {
        //检查是否完善信息，及更换用户
        const checkUser = await checkUserState({
          //不是hr
          callback1: () => {
            this.$router.replace({name: 'talentSearchIndex'});
            return false;
          },
          callback2: () => {
            //列表回到第一页，刷新数据
            location.reload();
            return false;
          },
        });
        //引导用户完善信息弹层
        if (!this.userInfoState) {
          //更新是否完善信息(状态库)
          let userInfo = await actions.hr_accounts.getUserinfo();
          this.toggleUserInfoState(userInfo)
          if (!this.userInfoState) {
            //提示
            this.toggleUserinfoTips(true);
            return false;
          }
        }
        //更改未读状态
        this.toggleViewed(listIndex, index);

        let token = item.resume.token;
        let is_favorite = item.is_favorite;
        let data = {
          token,
          job_id: item.resume.job_id,
          type: is_favorite ? 'dislike' : 'like'
        }

        // b向c发送通知
        if(!is_favorite && item.resume.cv_account_token){
          actions.im.sendNotifications({
            type: 'collect',
            cv_account_token: item.resume.cv_account_token,
            app_push: true,
            wechat_message: true
          })
        }

        actions.favorites.favorites_status(data).then(res => {
          if (res.code === 1000) {
            //更改列表收藏状态
            let getStoreResumeList = JSON.parse(JSON.stringify(this.getStoreResumeList.list));
            getStoreResumeList[listIndex].rec_resumes[index].is_favorite = item.is_favorite ? false : true;
            this.updateResumeListObj({key:'searchIndex', value: getStoreResumeList});

            this.$message({
              message: is_favorite ? '移除成功' : '已添加至储备人才',
              type: 'success'
            });
          } else {
            this.$message({
              message: res.message,
              type: 'error'
            });
          }
        })
      },
      //返回 满足条件的内容【有公司名称】
      checkWork(work_experiences) {
        let html = '';
        let workIndex = -1;
        work_experiences && work_experiences.forEach((item, index) => {
          if (item.company_name && workIndex < 0) {
            workIndex = index;
          }
        });
        if (workIndex > -1) {
          html += `<span class="ellipsis d-i-b max70">${work_experiences[workIndex].company_name}</span>`
          if (work_experiences[workIndex].title) {
            html += `<span class="flex1 ellipsis">${work_experiences[workIndex].title}</span>`
          }
        }
        return html
      },
      //返回 满足条件的内容【有学校名称】
      checkEdu(education_experiences, lang) {
        let html = '';
        let eduIndex = -1;
        education_experiences && education_experiences.forEach((item, index) => {
          if ((item.cust_uni_name || item.school[lang]) && eduIndex < 0) {
            eduIndex = index;
          }
        });
        if (eduIndex > -1) {
          html += `<span>${education_experiences[eduIndex].cust_uni_name || education_experiences[eduIndex].school[lang]}</span>`
          if (education_experiences[eduIndex].cust_major_name || education_experiences[eduIndex].major_name[lang]) {
            html += `<span>${education_experiences[eduIndex].cust_major_name || education_experiences[eduIndex].major_name[lang]}</span>`
          }
          if (education_experiences[eduIndex].cust_degree || education_experiences[eduIndex].degree_name[lang]) {
            html += `<span>${education_experiences[eduIndex].cust_degree || education_experiences[eduIndex].degree_name[lang]}</span>`
          }
        }
        if (html.length) {
          html = "<div class='afterText' style='width:100%;'>" + html
          html += "</div>"
        }
        return html
      },
      //过滤空公司信息
      filterWork(work_experiences, keyword_hit = []) {
        if (!work_experiences) {
          return []
        }
        let workList = []
        work_experiences = JSON.parse(JSON.stringify(work_experiences));
        work_experiences.forEach(item => {
          if (item.company_name || (item.resume && item.resume.title)) {
            workList.push(item)
          }
        })
        return workList;
      },
      //更改未读状态
      toggleViewed(listIndex, index) {
        let getStoreResumeList = JSON.parse(JSON.stringify(this.getStoreResumeList.list));
        let item = getStoreResumeList[listIndex].rec_resumes[index];
        if (item.resume.unsuited) {
          return false;
        }
        item.resume.unsuited = true;
        this.updateResumeListObj({key:'searchIndex', value: getStoreResumeList});

      },
      
      //不感兴趣
      handleClickUnsuitable(listIndex, itemIndex) {
        // 更新搜索主页参数
        this.updateSearchIndexObj({
          listIndex,
          itemIndex,
        });
        this.updateBlockStateFun({
          type:'unsuitableData',
          value: {
            showState: true, //是否展示不合适弹窗
            index: -1, //不合适index
          }
        })
      },
      //发送邀约
      async resumeApply(state, item, {listIndex, index}) {
        //检查是否完善信息，及更换用户
        const checkUser = await checkUserState({
          //不是hr
          callback1: () => {
            // this.$router.replace({name:'talentSearchIndex'});
            // return false;
          },
          callback2: () => {
            //列表回到第一页，刷新数据
            location.reload();
            return false;
          },
        });

        //引导用户完善信息弹层
        if (!this.userInfoState) {
          if(this.userJWT.h_t){
            //更新是否完善信息(状态库)
            let userInfo = await actions.hr_accounts.getUserinfo();
            this.toggleUserInfoState(userInfo)
          }
          if (!this.userInfoState) {
            //提示
            this.toggleUserinfoTips(true)
            return false;
          }
        }
        // 检查是否是继续沟通
        if(state){
          let { cv_account_token } = item.resume;
          if(!cv_account_token){
            this.$message({
              message: '对方身份状态异常，无法创建聊天',
              type: 'success'
            });
            return
          }
          let data = {
            b_token: this.hr_account_token,
            c_token: cv_account_token,
            identity: 'b'
          }
          actions.im.post_relationships(data).then(async res=>{
            if(res.code === 1000){
              // 恢复隐藏好友状态
              try {
                await actions.im.putRelationshipsHide({
                  b_token: this.hr_account_token, //用户token,
                  c_token: cv_account_token, //被曝光的关系id
                  b_hide: false, //是否隐藏联系人
                })
              } catch (error) { }
              setTimeout(() => {
                this.updateSmallChatOpenId('cv364674575gf')
                // window.open(`${window.location.origin}/talent/chat?chat_id=${cv_account_token}`)
                // this.$router.push({path:'/talent/chat', query:{ chat_id: cv_account_token}})
              }, 300);
            }
          })
          return
        }

        // 检查是否已经邀约过
        // if (state === 'applied') {
        //   this.$message({
        //     message: '人才已收到邀约！继续联系更多人才获得回复率更高哦~',
        //     type: 'warning'
        //   });
        //   return false;
        // }

        // 更新搜索主页参数
        this.updateSearchIndexObj({
          listIndex,
          itemIndex: index,
        });

        if (!this.showResumeApplyState) {
          //更新职位列表
          try {
            await this.getMyPosition()
          } catch (error) {}
          if (!this.myPosition.list.length) {
            //提示
            this.toggleUserinfoTips(true)
            //更新信息弹层 提示文案类型
            this.toggleTipsType(2)
            return false;
          }
          // 检查是否绑定手机号
          if(!this.bindData.phone_is_bound){
            this.showBindPhone = true
            return
          }
          //切换展示简历邀约样式
          this.updateBlockStateFun({type: 'showResumeApplyState', value: true})
          return false;
        }

      },
      //【详情】隐藏详情
      hideDetails(){
        this.showDetail = false;
        //重置详情的token相关数据
        // this.updateResumeDetailToken('');
        document.body.style.position = 'initial'
        document.body.style.overflow = 'initial'
      },

      //切换数据不感兴趣卡片状态
      toggleUnsuitableState(listIndex, index, state){
        let getStoreResumeList = JSON.parse(JSON.stringify(this.getStoreResumeList.list));
        getStoreResumeList[listIndex].rec_resumes[index].unsuitableCardState = state;
        this.updateResumeListObj({key:'searchIndex', value: getStoreResumeList});
      },
      //点击不合适
      toggleMarkVal(sitem, listIndex, itemIndex){
        let getStoreResumeList = JSON.parse(JSON.stringify(this.getStoreResumeList));
        //走同步接口
        let unsuited_reason = [sitem.id];
        let item = getStoreResumeList.list[listIndex].rec_resumes[itemIndex];

        let data = {
          type:'unsuited',
          unsuited_reason:unsuited_reason.join(','),
          way: 'recommend',
          platform: 'pc_browser',
          job_id: item.job_id || ''
        }

        // 提交不合适
        actions.resumes.putRecommendations(item.resume.token, data).then(res=>{
          if(res.code===1000){
            
            if(this.getStoreResumeList.list[listIndex].rec_resumes.length === 1){
              this.$emit('jobRecommendChange', {item: '',index: 0})
            }else{
              getStoreResumeList.list[listIndex].rec_resumes.splice(itemIndex, 1);
              this.updateResumeListObj({key: getStoreResumeList.listName, value: getStoreResumeList.list});
            }

          }else{
            this.$message({
              message: res.message,
              type: 'error'
            });
          }
        });
    
        //更改未读数量
        this.updateUnviewedJobDeliveriesCount();
      },
      //获取用户绑定信息
      getUsersBind(){
        actions.auth.getUserBind(this.userJWT.t).then(res=>{
          if(res.code === 1000){
            this.bindData = res.data;
          }
        })
      },
      //手机号绑定成功回调
      bindPhoneSuccess(){
        //重新获取用户绑定信息
        this.getUsersBind();
        this.showBindPhone = false;
      },
      // 关闭绑定手机号
      closeBindPhone(){
        this.showBindPhone = false;
      },

      filterInfoSections, //过滤模块
      filterCustomSections, //获取自定义模块数据
      getAge, //获取年龄
      applied_at, //时间
      getDegreeName, //获取专业名称
      schoolTag,
      getWorkTimeLength,

    },
    filters: {
      formatDate: function (value) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m;
      },
    }
  }
</script>

<style lang="scss" scoped>

  @import '@/assets/css/components/resumeList.scss';

  .managementList {
    // background: #FCFCFC;
    // 搜索匹配词
    .centerContent {
      overflow: initial;
    }
  }

  .talentList {
    min-height: 0px;

    .list {
      // margin-bottom: 0;
      // background: #FCFCFC;
      .unsuitableButton {
        right: 38px;
        bottom: 28px;
        display: none;

        .unsuitable, .suitable {
          line-height: 24px;
        }
      }

      &:hover {
        .unsuitableButton {
          display: block;
        }

        background: #fff;
      }
    }
  }

  //无数据
  .talent_notfound {
    height: 580px;

    img {
      display: block;
      width: 112px;
      height: 112px;
      margin: 0 auto;
      padding-top: 140px;
    }

    p {
      line-height: 22px;
      margin: 16px 42px 44px;
    }

    .button {
      width: 104px;
      height: 32px;
      line-height: 32px;
      border-radius: 2px;
      border: 1px solid #4183FF;
      margin: 0 auto;
    }
  }

  .userinfoTips {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background: rgba($color: #000, $alpha: 0.4);

    &tipsState1 {
      background: rgba($color: #000, $alpha: 0.2);
    }

    .tipsContent {
      left: 50%;
      top: 50%;
      box-sizing: border-box;
      width: 446px;
      box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.03);
      border-radius: 4px;
      padding: 32px 32px 26px;
      transform: translate(-50%, -50%);

      .tipsTitle {
        line-height: 24px;
        margin-bottom: 18px;
      }

      .tipsText {
        line-height: 20px;

        &.color_60 {
          margin-bottom: 6px;
        }
      }

      .buttons {
        margin-top: 26px;

        .confirm {
          width: 84px;
          line-height: 36px;
          border-radius: 2px;
          margin-left: 16px;
        }

        .cancel {
          box-sizing: border-box;
          width: 84px;
          height: 36px;
          line-height: 34px;
          border: 1px solid #D9D9D9;
          border-radius: 2px;
        }
      }
    }

    .markValList {
      padding: 24px 0 4px;

      .name {
        padding: 0 18px;
        line-height: 32px;
        border-radius: 2px;
        border: 1px solid #DADADA;
        margin: 12px 16px 0 0;

        &:hover {
          // color: #4183FF;
        }

        &.color_blue {
          border-color: #4183FF;
        }
      }
    }
  }

  .disabled-state{
    border-radius:20px;
    border:1px solid rgba(236,236,236,1)!important;
    font-weight:400;
    color:rgba(188,188,188,1);
  }
</style>